export default "__VITE_ASSET__f5542f00__"